import { useTheme } from '@emotion/react'
import { isEmpty } from '@open-tender/utils'
import { selectAllergens, useAppSelector } from '@open-tender/cloud'
import {
  MenuItemAllergen,
  MenuItemAllergenImage,
  MenuItemAllergensView,
} from './MenuItemAllergens.styled'

const MenuItemAllergens = ({ allergens }: { allergens: string[] }) => {
  const theme = useTheme()
  const { displayType, prefix } = theme.menuItems.allergens
  const { lookup } = useAppSelector(selectAllergens)
  const hasLookup = lookup && !isEmpty(lookup)
  const showTagImages = hasLookup && displayType === 'IMAGE'
  const allergensString = prefix ? `${prefix} ${allergens.join(', ')}` : null

  if (!allergens.length || displayType === 'HIDDEN') return null

  return (
    <MenuItemAllergensView>
      {showTagImages ? (
        allergens.map((allergen) => (
          <MenuItemAllergenImage key={allergen}>
            <img
              src={lookup[allergen]?.imageUrl}
              alt={lookup[allergen]?.name}
            />
          </MenuItemAllergenImage>
        ))
      ) : allergensString ? (
        <MenuItemAllergen>{allergensString}</MenuItemAllergen>
      ) : (
        allergens.map((allergen) => (
          <MenuItemAllergen key={allergen}>{allergen}</MenuItemAllergen>
        ))
      )}
    </MenuItemAllergensView>
  )
}

export default MenuItemAllergens
